import React, { useState } from "react";
import {
  StyledDiv,
  StyledElementContainer,
  StyledTag,
  StyledTypography,
} from "./QuickAccessIcon.styles";
import { QuickAccessIconProps } from "./QuickAccessIcon.types";
import { Icon } from "../Icon/Icon";
import Box from "../../primitives/Box/Box";

export const QuickAccessIcon: React.FC<QuickAccessIconProps> = ({
  iconName,
  iconColor = "#000",
  label,
  tagText = undefined,
  backgroundColor,
  tagColor = "#F08D32",
  dataCy,
  showEllipse = false,
  ellipseColor = "#06C270",
  ellipsePosition = "top-right",
  variant = "square",
  handleClick,
}) => {
  return (
    <StyledDiv>
      <StyledElementContainer
        key={label}
        data-cy={dataCy}
        onClick={() => handleClick()}
      >
        {tagText && (
          <StyledTag
            type="round"
            backgroundColor={tagColor}
            label={tagText}
            onClick={(e) => {
              e.stopPropagation();
              handleClick();
            }}
          />
        )}
        <Box
          backgroundColor={backgroundColor}
          position="relative"
          height={"40px"}
          width={"40px"}
          display="flex"
          alignItems="center"
          justifyContent="center"
          borderRadius={variant === "square" ? "5px" : "50%"}
        >
          {showEllipse && (
            <Box
              position="absolute"
              top={ellipsePosition.includes("top") ? "-5px" : "auto"}
              bottom={ellipsePosition.includes("bottom") ? "-5px" : "auto"}
              right={ellipsePosition.includes("right") ? "-5px" : "auto"}
              left={ellipsePosition.includes("left") ? "-5px" : "auto"}
              width="10px"
              height="10px"
              borderRadius="50%"
              backgroundColor={ellipseColor}
              border="1px solid #fff"
            />
          )}
          <Icon name={iconName} color={iconColor} size="16"></Icon>
        </Box>
        <StyledTypography>{label}</StyledTypography>
      </StyledElementContainer>
    </StyledDiv>
  );
};
